import { ModalParticipants } from '@lideralia/alife-uikit/dist/organisms/Modals/Participants';
import React from 'react';

export const ParticipantsTemplate = (props) => <ModalParticipants {...props} />;
